import React, { useState } from 'react';
import '../css/CollaborationsPage.css';

const CollaborationsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    collaboration_idea: '',
    collaboration_type: 'other',
    expected_timeline: '',
    budget_range: '',
    attached_file: null
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Mock collaborators data
  const collaborators = [
    {
      id: 1,
      name: "TechFlow Studios",
      logo: "https://via.placeholder.com/120x80/c10000/ffffff?text=TF",
      summary: "Co-created the AI Identity Project for emerging artists"
    },
    {
      id: 2,
      name: "Urban Design Lab",
      logo: "https://via.placeholder.com/120x80/333333/ffffff?text=UDL",
      summary: "Developed smart city visualization tools"
    },
    {
      id: 3,
      name: "Quantum Innovations",
      logo: "https://via.placeholder.com/120x80/0066cc/ffffff?text=QI",
      summary: "Built next-gen fintech branding ecosystem"
    },
    {
      id: 4,
      name: "Creative Commons",
      logo: "https://via.placeholder.com/120x80/ff6600/ffffff?text=CC",
      summary: "Launched open-source design residency program"
    },
    {
      id: 5,
      name: "MIT Media Lab",
      logo: "https://via.placeholder.com/120x80/9900cc/ffffff?text=MIT",
      summary: "Research partnership on digital creativity tools"
    },
    {
      id: 6,
      name: "Startup Accelerator",
      logo: "https://via.placeholder.com/120x80/00cc66/ffffff?text=SA",
      summary: "Mentored 15 startups in digital transformation"
    }
  ];

  const collaborationTypes = [
    {
      title: "Tech x Creativity Labs",
      description: "Experimental projects merging technology with artistic expression",
      icon: "🧪"
    },
    {
      title: "Branding Co-Launches",
      description: "Strategic partnerships to launch innovative brand experiences",
      icon: "🚀"
    },
    {
      title: "Startup Acceleration",
      description: "Mentorship and development programs for emerging companies",
      icon: "⚡"
    },
    {
      title: "Design Residency Programs",
      description: "Immersive experiences for designers and creative professionals",
      icon: "🎨"
    }
  ];

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  // FIXED COLLABORATION REQUEST HANDLER - Connected to Django Backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Check if there's a file to upload
      if (formData.attached_file) {
        // Use FormData for file upload
        const submitData = new FormData();
        
        // Append all form fields (excluding null/empty values)
        Object.keys(formData).forEach(key => {
          if (formData[key] !== null && formData[key] !== '') {
            submitData.append(key, formData[key]);
          }
        });

        console.log('Collaboration Request Data (with file):', formData);

        const response = await fetch('http://127.0.0.1:8000/api/contact/collaboration/', {
          method: 'POST',
          body: submitData
        });

        const data = await response.json();
        handleResponse(response, data);

      } else {
        // Use JSON for data without file
        const submitData = {
          name: formData.name,
          email: formData.email,
          organization: formData.organization || '', // Ensure empty string instead of null
          collaboration_idea: formData.collaboration_idea,
          collaboration_type: formData.collaboration_type,
          expected_timeline: formData.expected_timeline || '', // Ensure empty string instead of null
          budget_range: formData.budget_range || '' // Ensure empty string instead of null
        };

        console.log('Collaboration Request Data (JSON):', submitData);

        const response = await fetch('http://127.0.0.1:8000/api/contact/collaboration/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(submitData)
        });

        const data = await response.json();
        handleResponse(response, data);
      }

    } catch (error) {
      console.error('Network error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Helper function to handle response
  const handleResponse = (response, data) => {
    if (response.ok) {
      console.log('Success:', data);
      alert('Thank you for your collaboration idea! We\'ll be in touch soon.');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        organization: '',
        collaboration_idea: '',
        collaboration_type: 'other',
        expected_timeline: '',
        budget_range: '',
        attached_file: null
      });
      
      // Reset file input
      const fileInput = document.getElementById('attached_file');
      if (fileInput) fileInput.value = '';
      
    } else {
      console.error('Error Response:', data);
      console.error('Status:', response.status);
      
      // More detailed error handling
      if (data.error) {
        alert('Error: ' + data.error);
      } else if (data.details) {
        alert('Validation Error: ' + data.details);
      } else if (data.collaboration_idea) {
        alert('Collaboration Idea Error: ' + data.collaboration_idea[0]);
      } else if (data.name) {
        alert('Name Error: ' + data.name[0]);
      } else if (data.email) {
        alert('Email Error: ' + data.email[0]);
      } else {
        alert('Error submitting collaboration request. Please check all required fields and try again.');
      }
    }
  };

  const scrollToForm = () => {
    document.getElementById('collab-collaboration-form').scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <div className="collab-collaborations-page">
      {/* Hero Section */}
      <section className="collab-hero-section">
        <div className="collab-hero-content">
          <h1 className="collab-hero-title">Let's Build the Future, Together.</h1>
          <p className="collab-hero-subtitle">
            At Red Fibre, we believe the most groundbreaking innovations emerge from 
            collaborative minds. Partner with us to push the boundaries of digital creativity, 
            design thinking, and technological innovation.
          </p>
          <button className="collab-cta-button" onClick={scrollToForm}>
            Start a Collaboration
          </button>
        </div>
        <div className="collab-hero-visual">
          <div className="collab-collaboration-nodes">
            <div className="collab-node collab-node-1"></div>
            <div className="collab-node collab-node-2"></div>
            <div className="collab-node collab-node-3"></div>
            <div className="collab-node collab-node-4"></div>
            <div className="collab-connection-line collab-line-1"></div>
            <div className="collab-connection-line collab-line-2"></div>
            <div className="collab-connection-line collab-line-3"></div>
          </div>
        </div>
      </section>

      {/* Our Collaborators */}
      <section className="collab-collaborators-section">
        <div className="collab-container">
          <h2 className="collab-section-title">Our Collaborators</h2>
          <p className="collab-section-subtitle">
            Trusted partners who've helped us shape the future of digital creativity
          </p>
          <div className="collab-collaborators-grid">
            {collaborators.map(collaborator => (
              <div key={collaborator.id} className="collab-collaborator-card">
                <div className="collab-card-image">
                  <img src={collaborator.logo} alt={collaborator.name} />
                </div>
                <div className="collab-card-content">
                  <h3 className="collab-collaborator-name">{collaborator.name}</h3>
                  <p className="collab-collaborator-summary">{collaborator.summary}</p>
                </div>
                <div className="collab-card-overlay">
                  <span className="collab-overlay-text">View Partnership</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Types of Collaborations */}
      <section className="collab-collaboration-types">
        <div className="collab-container">
          <h2 className="collab-section-title">Types of Collaborations</h2>
          <div className="collab-types-grid">
            {collaborationTypes.map((type, index) => (
              <div key={index} className="collab-type-card">
                <div className="collab-type-icon">{type.icon}</div>
                <h3 className="collab-type-title">{type.title}</h3>
                <p className="collab-type-description">{type.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Collaboration Form */}
      <section className="collab-form-section" id="collab-collaboration-form">
        <div className="collab-container">
          <div className="collab-form-header">
            <h2 className="collab-section-title">Ready to Collaborate?</h2>
            <p className="collab-section-subtitle">
              Tell us about your vision and let's create something extraordinary together
            </p>
          </div>
          
          <form className="collab-collaboration-form" onSubmit={handleSubmit}>
            <div className="collab-form-grid">
              <div className="collab-form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  minLength={2}
                />
              </div>
              
              <div className="collab-form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="collab-form-group">
                <label htmlFor="organization">Organization</label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleInputChange}
                  placeholder="Your company or organization (optional)"
                />
              </div>
              
              <div className="collab-form-group">
                <label htmlFor="collaboration_type">Collaboration Type</label>
                <select
                  id="collaboration_type"
                  name="collaboration_type"
                  value={formData.collaboration_type}
                  onChange={handleInputChange}
                >
                  <option value="project_partnership">Project Partnership</option>
                  <option value="technology_collaboration">Technology Collaboration</option>
                  <option value="content_collaboration">Content Collaboration</option>
                  <option value="research_development">Research & Development</option>
                  <option value="marketing_partnership">Marketing Partnership</option>
                  <option value="resource_sharing">Resource Sharing</option>
                  <option value="skill_exchange">Skill Exchange</option>
                  <option value="joint_venture">Joint Venture</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div className="collab-form-group">
                <label htmlFor="expected_timeline">Expected Timeline</label>
                <input
                  type="text"
                  id="expected_timeline"
                  name="expected_timeline"
                  value={formData.expected_timeline}
                  onChange={handleInputChange}
                  placeholder="e.g., 3 months, 6 months, ongoing"
                />
              </div>
              
              <div className="collab-form-group">
                <label htmlFor="budget_range">Budget Range</label>
                <input
                  type="text"
                  id="budget_range"
                  name="budget_range"
                  value={formData.budget_range}
                  onChange={handleInputChange}
                  placeholder="e.g., $5,000-$10,000, to be discussed"
                />
              </div>
              
              <div className="collab-form-group">
                <label htmlFor="attached_file">Attach File (Optional)</label>
                <input
                  type="file"
                  id="attached_file"
                  name="attached_file"
                  onChange={handleInputChange}
                  accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.jpeg,.png"
                />
                <small>Supported formats: PDF, DOC, DOCX, PPT, PPTX, JPG, PNG (Max 10MB)</small>
              </div>
            </div>
            
            <div className="collab-form-group collab-full-width">
              <label htmlFor="collaboration_idea">Collaboration Idea *</label>
              <textarea
                id="collaboration_idea"
                name="collaboration_idea"
                value={formData.collaboration_idea}
                onChange={handleInputChange}
                placeholder="Describe your collaboration idea, project goals, or how you'd like to work together... (minimum 100 characters)"
                rows="6"
                required
                minLength={100}
              ></textarea>
              <small>{formData.collaboration_idea.length}/100 characters minimum</small>
            </div>
            
            <button type="submit" className="collab-submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Pitch Us Your Idea'}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default CollaborationsPage;